import React from 'react';
import { Info } from 'lucide-react';
import { getAppVersion } from '../../utils/versionUtils';

interface VersionIndicatorProps {
  className?: string;
  showIcon?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const VersionIndicator: React.FC<VersionIndicatorProps> = ({
  className = '',
  showIcon = false,
  size = 'small'
}) => {
  // Get version from utility (uses environment variable set during build)
  // This version is also used for cache-busting all static assets
  const version = getAppVersion();

  const sizeClasses = {
    small: 'text-xs',
    medium: 'text-sm',
    large: 'text-base'
  };

  const iconSizes = {
    small: 12,
    medium: 14,
    large: 16
  };

  return (
    <div className={`inline-flex items-center gap-1 ${sizeClasses[size]} ${className}`}>
      {showIcon && <Info size={iconSizes[size]} />}
      <span>v{version}</span>
    </div>
  );
};

export default VersionIndicator;
